///<reference path="../../App/plugins/DefinitelyTyped/bootstrap-select.d.ts"/>
import {Component, OnInit} from '@angular/core';
import {Constants} from '../Services/Constants';
import {HTTPService} from '../Services/http.service';
import {Observable}   from 'rxjs/Observable';
import {filter} from '../App/search.pipe';
import {DatePipe} from "@angular/common";
import {MySharedService} from '../App/shared.service'

@Component({
    templateUrl: './AppViews/Timesheet/timesheet.html'    
})

export class TimesheetComponent implements OnInit {
    showLoader:boolean=false;
    constants:Constants;
    projectList:any=[];
    timesheetItems:any=[];    
    userDetail: any;
    getProjectUrl:any;
    filter:any={'ProjectId':"",'FromDate':moment().subtract(1, 'days').format('DD/MM/YYYY'),'ToDate':moment().format('DD/MM/YYYY')};
    addTimeSheetFlag:any;
    teamItems:any[]=[];
    constructor(private _httpService: HTTPService, private _sharedService: MySharedService, private datePipe: DatePipe) {
        this.constants = new Constants();
        this.userDetail = JSON.parse(localStorage.getItem("userDetail"));
       // if(this.userDetail.RoleId==3){
            this.getProjectUrl="Project/GetAssignedProject"
        // }else{
        //      this.getProjectUrl="Project/GetProject"
        // }
        this.addTimeSheetFlag=JSON.parse(localStorage.getItem('TimesheetFilters'));
        if(this.addTimeSheetFlag!=null && typeof this.addTimeSheetFlag != 'undefined'){
            this.filter=JSON.parse(localStorage.getItem('TimesheetFilters'));
            localStorage.removeItem("TimesheetFilters");
        }

    }

    ngOnInit() {        
      this.GetProjectList();
      this.GetTimesheet();       
    }

    ngAfterViewInit() {
        
        $('.date').datetimepicker({
            format: 'DD/MM/YYYY'
        });
        $('#date_report_from').datetimepicker({
            defaultDate:moment().subtract(1, 'days'),
            format: 'DD/MM/YYYY',
            useCurrent: false
        });

        $("#show-filter").click(function(){$(".filter-form").slideToggle()});

    }

    ngAfterViewChecked () {
        // if(this.projectList.length > 0){
        //     $('.project').selectpicker({
        //                 style: 'btn-info',
        //                 size: 4
        //                 })
        // } 
    }    

    public clearFilter(){
        $(".project").val('');
        // $(".project").val('').selectpicker('refresh');
        this.filter={'ProjectId':"",'FromDate':moment().subtract(1, 'days').format('DD/MM/YYYY'),'ToDate':moment().format('DD/MM/YYYY')};
    }

    GetProjectList(){
        this.showLoader=true;
        var UserId = 0;
        var TeamId = 0;
         if(this.userDetail.RoleId != 0){
             UserId = this.userDetail.SiteUserId;
            //  if(this.userDetail.RoleId==3){
                 TeamId=0
            //  }else{
            //     TeamId = this.userDetail.TeamID;
            //  }
         }
        this._httpService.ajaxPost(this.getProjectUrl,
        {"ProjectId":0,"OwnerTeamId":TeamId,"ProjectType":0,"Status":0,"UserId":UserId}).subscribe(
            data =>{
                this.projectList=data["ProjectList"];
            },
            err => { console.log("GetProjectList Failed"); this.showLoader=false; },
            () => { this.showLoader=false;}
        );      
    }

    GetTimesheet(){
            this.showLoader=true;
            this._httpService.ajaxPost("Timesheet/GetTimesheet",
            {
            "TimesheetId" : 0,
            "UserId" : this.userDetail.SiteUserId,
            "ProjectId" : this.filter.ProjectId,
            "FromDate" : this.filter.FromDate,
            "ToDate" : this.filter.ToDate,
            "TaskTypeId":0,
            "TaskGroupId":0,
            "TeamId":this.userDetail.TeamID,
            "LoggedInUser":this.userDetail.SiteUserId   
            }).subscribe(
                data =>{
                    this.timesheetItems=data["TimesheetList"];
                },
                err => {console.log("GetTimesheetList Failed"); this.showLoader=false; },
                () => { this.showLoader=false;}
            );      
    }

    setFilters(){
        this.filter={'ProjectId':this.filter.ProjectId,'FromDate':this.filter.FromDate,'ToDate':this.filter.ToDate};
        localStorage.setItem("TimesheetFilters",JSON.stringify(this.filter));
    }

}


/** WEBPACK FOOTER **
 ** ./TypeScripts/Timesheet/timesheet.component.ts
 **/